export default class Category {
  constructor(key, name, description, warning, kpis) {
    this.key = key;
    this.name = name;
    this.description = description;
    this.warning = warning;
    this.KPIs = kpis;
  }

  getKey = () => this.key;

  getLevels = () =>
    this.KPIs.map(kpi => kpi.level).reduce(
      (levels, current) =>
        levels.includes(current) ? levels : [...levels, current],
      [0]
    );

  getKpisByLevel = level => this.KPIs.filter(kpi => kpi.level === level);
}
